export default __webpack_public_path__ + "static/media/line-chart.af230147.png";